
export default {
  name: 'GrievancepolicyContentRU'
}
